import dashboardSaga from "./sagas";

export default [dashboardSaga()];
